module.exports = __webpack_public_path__ + "static/media/mh-3.fff3bb89.jpg";